export const fontWeightMap = {
  light: 300,
  regular: 400,
  medium: 500,
  bold: 700,
  extraBold: 800,
};
